import { useEffect, useContext, useState } from 'react'
import { useStorage } from 'hooks'
import { GeneralContext } from 'context'
import { ThemeProvider } from 'styled-components'
import UserRoutes from './routes'
import GlobalStyle, { lightTheme, darkTheme } from './styles/global'

export default function App() {
  const [token] = useStorage('Token')
  const general = useContext(GeneralContext)

  useEffect(() => {
    // general.gestor.syncronize(token)
  }, [])
  const [isDarkMode, setIsDarkMode] = useState(false)
  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <GlobalStyle />
      <UserRoutes />
    </ThemeProvider>
  )
}
